import { render } from "./TranslationForm.vue?vue&type=template&id=57fc21ef&scoped=true"
import script from "./TranslationForm.vue?vue&type=script&lang=js"
export * from "./TranslationForm.vue?vue&type=script&lang=js"

import "./TranslationForm.vue?vue&type=style&index=0&id=57fc21ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fc21ef"]])

export default __exports__